const attachStyles = (element, stylesObj) => {
  for (const [key, value] of Object.entries(stylesObj)) {
    element.style[key] = value
  }
}

module.exports = {
  attachStyles: attachStyles
}
